import { AuditLogsResponse } from '@services/audit-logs/interfaces/audit-logs.interfaces';
import { Mock } from '@shared/interfaces/mock.interface';

export const AUDIT_LOGS_RESPONSE: AuditLogsResponse = {
  items: [
    {
      id: 'log-1',
      createdAt: '2026-10-08T19:40:36.314Z',
      actorEmail: 'admin@argentusmundo3d.cl',
      action: 'update',
      entityType: 'product',
      entityId: '230b4cef-f09c-480e-a70d-4b56f125f4c6',
      entityLabel: 'Maceta Suculenta',
      changedFields: ['name', 'category', 'images'],
      changes: {
        name: { before: 'Maceta', after: 'Maceta Suculenta' },
        category: { before: 'Deco Hogar', after: 'Mini macetas' },
        images: { before: 'a.png (120 KB)', after: 'b.png (98 KB)' },
      },
      requestId: 'b532c4b2-5d36-4185-b963-4e04aa45f2c4',
    },
    {
      id: 'log-2',
      createdAt: '2026-10-08T18:12:02.010Z',
      actorEmail: 'admin@argentusmundo3d.cl',
      action: 'status_change',
      entityType: 'order',
      entityId: '9da6d2d2-6dd9-41e7-91c2-4d9b0c3a0ddc',
      entityLabel: '1111119',
      changedFields: ['status', 'trackingCode'],
      changes: {
        status: { before: 'pending', after: 'shipped' },
        trackingCode: { before: null, after: '123456789012' },
      },
      requestId: '7fe804f9-52f7-422d-a4d7-4ca3b6d9bd3f',
    },
    {
      id: 'log-3',
      createdAt: '2026-10-07T14:00:00.000Z',
      actorEmail: 'admin@argentusmundo3d.cl',
      action: 'create',
      entityType: 'material_color',
      entityId: 'col-1',
      entityLabel: 'Verde menta',
      changedFields: [],
      changes: null,
      requestId: 'e741825c-5d6b-4495-8034-a4260ce12d20',
    },
  ],
  total: 3,
  page: 1,
  pageSize: 20,
};

export const GET_AUDIT_LOGS_MOCK: Mock<AuditLogsResponse> = {
  success: [{ response: AUDIT_LOGS_RESPONSE }],
  failures: [],
};
